import { img } from "@/lib/images";

const g = (num: string, caption: string, captionEn: string) => ({
  key: `activities/tour-info/tour-gallery/tour-galerie-${num}_full.jpg`,
  thumb: img(`activities/tour-info/tour-gallery/tour-galerie-${num}_thumb.jpg`),
  full: img(`activities/tour-info/tour-gallery/tour-galerie-${num}_full.jpg`),
  caption,
  captionEn,
});

export const tourGalleryImages = [
  g("01", "Tanah Lot Tempel", "Tanah Lot Temple"),
  g("02", "Barong besucht Tempel", "Barong visits the temple"),
  g("03", "Reisfeldlandschaft", "Rice field landscape"),
  g("04", "Batu-Karu-Tempel", "Batu Karu Temple"),
  g("05", "Reisterrassen", "Rice terraces"),
  g("06", "Lokaler Markt", "Local market"),
  g("07", "Danau-Beratan-Tempel", "Lake Beratan Temple"),
  g("08", "Straßenhändler", "Street vendor"),
  g("09", "Tempelzeremonie", "Temple ceremony"),
  g("10", "Dorfmädchen", "Village girl"),
  g("11", "Unsere Fans", "Our fans"),
  g("12", "Taman Ayun Tempel Mengwi", "Taman Ayun Temple Mengwi"),
  g("13", "Bali-Landschaft", "Bali landscape"),
  g("14", "Unsere Fans", "Our fans"),
  g("15", "Blumenpflückerin", "Flower picker"),
  g("16", "Reispflanzer", "Rice farmer"),
  g("17", "Reispflanzer", "Rice farmer"),
  g("18", "Reisfeld pflügen", "Ploughing the rice field"),
  g("19", "Regenwaldwanderung", "Rainforest trek"),
  g("20", "Affenwald", "Monkey forest"),
  g("21", "Bergdorf", "Mountain village"),
  g("22", "Ayung-Fluss", "Ayung River"),
  g("23", "Schulkinder", "School children"),
  g("24", "Tempeltänzer", "Temple dancer"),
  g("25", "Tempeltänzerinnen", "Temple dancers"),
  g("26", "Tempeltänzerinnen", "Temple dancers"),
  g("27", "Tempeltänzerinnen", "Temple dancers"),
  g("28", "Tempelzeremonie", "Temple ceremony"),
  g("29", "Tempeltänzerinnen", "Temple dancers"),
  g("30", "Tempelzeremonie", "Temple ceremony"),
  g("31", "Balinesische Opfergaben", "Balinese offerings"),
  g("32", "Tempelzeremonie", "Temple ceremony"),
  g("33", "Balinesische Boote", "Balinese boats"),
  g("34", "Strandwanderer", "Beach walker"),
  g("35", "Tirta Gangga", "Tirta Gangga"),
  g("36", "Reisterrassen", "Rice terraces"),
  g("37", "Buddhistischer Tempel", "Buddhist temple"),
  g("38", "Buyan-Kratersee", "Lake Buyan Crater"),
  g("39", "Balis Vulkane", "Bali's volcanoes"),
];